import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Icon = React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
      size = _ref.size,
      ariaLabel = _ref['aria-label'],
      color = _ref.color,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "size", "aria-label", "color", "className", "children"]);

  return React.createElement("i", Object.assign({
    ref: ref,
    "aria-label": ariaLabel || name,
    className: classNames('icon', "icon-" + name, size && "icon-" + size, color && "text-" + color, className)
  }, rest), children);
});
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  'aria-label': PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node
};
export default Icon;